import { toAbsolutePhotoUrl } from "../../../../../../../services/settingsPhotoServices";

export const HEADER_PLACEHOLDER_1 = "/img/no-image.jpg";
export const HEADER_PLACEHOLDER_2 = "/img/no-image.jpg";
export const HOME_DEFAULT_LOGO = "/img/no-image.jpg";

export const DEFAULT_HOME_SETTINGS = {
  header_url1: "",
  header_texte1: "",
  header_url2: "",
  header_texte2: "",
  about_title: "",
  about_content: "",
  carrousel_id: "",
  logo_club: "",
};

export function unwrapSettings(data) {
  if (Array.isArray(data)) return data[0] || null;
  return data || null;
}

export function withBust(url, version) {
  if (!url) return url;
  return `${url}${url.includes("?") ? "&" : "?"}v=${version}`;
}

export function stripHtml(value = "") {
  return String(value).replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

export function validateImageFile(file) {
  if (!file) return "";

  const validType = /^image\/(png|jpe?g|webp)$/i.test(file.type);

  if (!validType) {
    return "Format image non supporté. Utilisez PNG, JPG ou WEBP.";
  }

  if (file.size > 10 * 1024 * 1024) {
    return "Image trop volumineuse. Taille maximale : 10 Mo.";
  }

  return "";
}

export function normalizeHomeSettingsPayload(settings) {
  return {
    ...settings,
    header_url1: String(settings?.header_url1 || "").trim(),
    header_texte1: String(settings?.header_texte1 || ""),
    header_url2: String(settings?.header_url2 || "").trim(),
    header_texte2: String(settings?.header_texte2 || ""),
    about_title: String(settings?.about_title || "").trim(),
    about_content: String(settings?.about_content || ""),
    carrousel_id: settings?.carrousel_id || null,
  };
}

export function buildHeaderImages(settings, imgVersion) {
  const raw1 = settings.header_url1?.trim() || HEADER_PLACEHOLDER_1;
  const raw2 = settings.header_url2?.trim() || HEADER_PLACEHOLDER_2;

  const abs1 = toAbsolutePhotoUrl(raw1) || HEADER_PLACEHOLDER_1;
  const abs2 = toAbsolutePhotoUrl(raw2) || HEADER_PLACEHOLDER_2;

  return [
    {
      id: "header1",
      label: "Header image 1",
      src: withBust(abs1, imgVersion.header1),
      fallback: HEADER_PLACEHOLDER_1,
      text: settings.header_texte1 || "",
      align: "left",
    },
    {
      id: "header2",
      label: "Header image 2",
      src: withBust(abs2, imgVersion.header2),
      fallback: HEADER_PLACEHOLDER_2,
      text: settings.header_texte2 || "",
      align: "right",
    },
  ];
}

export function getSelectedGallery(galleries, carrouselId) {
  if (!carrouselId) return null;

  return (Array.isArray(galleries) ? galleries : []).find(
    (gallery) => String(gallery.id) === String(carrouselId)
  );
}

export function getActiveCarouselPhotos(gallery) {
  const photos = Array.isArray(gallery?.photos) ? gallery.photos : [];
  return photos.filter((photo) => !!photo.is_active).slice(0, 12);
}

export function calculateHomeContentStats(settings, galleries, selectedGallery) {
  const hasHeader1 = !!String(settings?.header_url1 || "").trim();
  const hasHeader2 = !!String(settings?.header_url2 || "").trim();
  const hasHeaderText1 = !!stripHtml(settings?.header_texte1 || "");
  const hasHeaderText2 = !!stripHtml(settings?.header_texte2 || "");
  const hasAbout = !!String(settings?.about_title || "").trim() || !!stripHtml(settings?.about_content || "");
  const hasCarousel = !!settings?.carrousel_id;

  return {
    headersConfigured: Number(hasHeader1) + Number(hasHeader2),
    headerTextsConfigured: Number(hasHeaderText1) + Number(hasHeaderText2),
    hasAbout,
    hasCarousel,
    galleriesCount: Array.isArray(galleries) ? galleries.length : 0,
    selectedGalleryTitle: selectedGallery?.titre || "",
  };
}

export function extractUploadedHeaderUrl(response) {
  const data = response?.data ?? response;

  return (
    data?.url ||
    data?.imageUrl ||
    data?.header_url ||
    data?.data?.url ||
    data?.data?.imageUrl ||
    ""
  );
}